import React, { Fragment } from 'react';

import RequiredInput from '../../../common/RequiredInput';
import useDialog from '../../../hooks/useDialog';

import FieldDialog from './fieldPickDialog';

const Form = (props) => {
  const { onClose, onSubmit, showDialog, setShowDialog } = useDialog({
    showDialog: false,
  });
  const genTitle = () => {
    if (props.dataList.length > 0) {
      return (
        <div className="trans trans-tt">
          <div className="bef">
            <p className="name">{props.keyLabel}</p>
          </div>
          <span className="center-wd"></span>
          <div className="aft">
            <p className="name">{props.valueLabel}</p>
          </div>
          <span className="iconarea"></span>
        </div>
      );
    }
    return null;
  };

  const genValueList = () => {
    const res = [];
    props.dataList.forEach((e) => {
      res.push({
        value: e.key,
      });
    });

    return res;
  };

  const handleReset = (value) => {
    const res = [];
    value.forEach((e) => {
      res.push(e.value || e);
    });
    props.onReset(res);

    onSubmit();
  };
  return (
    <Fragment>
      <span className="info-tt">{props.title}</span>
      <div className="info-des">
        <div className="field-trans-form">
          {genTitle()}
          {props.dataList.map((item, index) => (
            <div className="trans trans-con">
              <div className="bef">
                <div className="trans">
                  <RequiredInput
                    placeholder={`请输入${props.keyLabel}`}
                    value={item.key}
                    onChange={(event, value) => {
                      props.onItemChange(index, 'key', value);
                    }}
                    status={item.status}
                    disabled
                  />
                </div>
              </div>
              <span className="center-wd">对应</span>
              <div className="aft">
                <RequiredInput
                  placeholder={`请输入${props.valueLabel}`}
                  value={item.value}
                  onChange={(event, value) => {
                    props.onItemChange(index, 'value', value);
                  }}
                  status={item.status}
                />
              </div>
              <i
                className="iconarea"
                onClick={() => {
                  props.onDeleteItem(index);
                }}
              >
                <i className="icon icon-delete"></i>
              </i>
            </div>
          ))}
          <a
            className="more-set"
            onClick={() => {
              setShowDialog(true);
            }}
          >
            更多字段设置
          </a>
          {showDialog ? (
            <FieldDialog showDialog={showDialog} onSubmit={handleReset} onClose={onClose} value={genValueList()} />
          ) : null}
        </div>
      </div>
    </Fragment>
  );
};

export default Form;
